import { FC, useEffect } from 'react'

import NiceModal from '@ebay/nice-modal-react'
import { useWelcomeModalDismissal } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/hooks/useWelcomeModalDismissal/useWelcomeModalDismissal'
import WelcomeModal from '../WelcomeModal'
import { useGiftGivers } from '../../context/GiftGiversProvider'
import GiftTrackerListItem from './GiftTrackerListItem'
import EmptyState from './EmptyState'
import css from './GiftTrackerList.styles.scss'
import LoadingState from './LoadingState'

type GiftTrackerListProps = {
  registryUrl: string | undefined
}

const GiftTrackerList: FC<GiftTrackerListProps> = ({ registryUrl }) => {
  const { giftGivers = [], isLoading, search: searchFilter } = useGiftGivers()
  const {
    isWelcomeModalDismissed,
    setModalWasOpened,
    setWelcomeModalDismissed,
  } = useWelcomeModalDismissal()

  useEffect(() => {
    if (!isWelcomeModalDismissed) {
      setModalWasOpened(true)
      NiceModal.show(WelcomeModal).then(() => {
        setWelcomeModalDismissed(true)
      })
    }
  }, [isWelcomeModalDismissed, setWelcomeModalDismissed])

  if (isLoading || !isWelcomeModalDismissed) {
    return <LoadingState />
  }

  if (giftGivers.length === 0) {
    return <EmptyState registryUrl={registryUrl} searchFilter={searchFilter} />
  }

  const giftTrackerListItems = giftGivers.map((giftGiver) => (
    <GiftTrackerListItem giftGiver={giftGiver} key={giftGiver.id} />
  ))

  return (
    <div className={css.GiftTrackerList} data-testid="GiftTrackerList">
      {giftTrackerListItems}
    </div>
  )
}

export default GiftTrackerList
